/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_UntitledInputs */



/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Agenda_UntitledInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_untitled = /** @type {((inputs?: Agenda_UntitledInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_UntitledInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zonder titel")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans titre")
	return /** @type {LocalizedString} */ ("Untitled")
});